//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { noticeTemplateTypes, candidateUserAtributes } from '../common';
import { throttle } from '@/utils/util';
import selectMetaDialogVue from './select-meta-dialog.vue';
import InputJson from '@/components/inputJson';
import Clipboard from 'nges-common/src/web/components/Clipboard';
import CodeEditor from '../../notice/noticeDetail/editor.vue';
import MessageBox from '@/components/messageBox';
import RichEditor from '@/components/richEditor';
import { difference } from 'lodash';
import uploadImg from '@/components/uploadImg';
import { mapGetters } from 'vuex';

const _ = { difference };
export default {
  components: {
    selectMetaDialogVue,
    RichEditor,
    InputJson,
    Clipboard,
    CodeEditor,
    MessageBox,
    uploadImg,
  },
  data() {
    return {
      id: '',
      userId: '',
      title: '通知消息事件详情',
      basicInfo: {
        name: '',
        keys: [],
        event_key: '',
        remark: '',
      },
      templateInfo: {
        title: '',
        content: '',
        to: [],
        to2: '',
        variable: '',
        subref: '',
        system_type: '',
        wxmsg_type: 1,
        platform: [1, 2],
        editor_type: 1,
        script: '',

        // 按钮交互型字段
        source_switch: false,
        source: {
          icon_url: [],
          desc: '',
        },

        main_title: {
          title: '',
          desc: '',
        },

        horizontal_content_list_switch: false,
        horizontal_content_list: [{ keyname: '', value: '' }],

        card_action_switch: false,
        card_action: {
          type: '',
          url: '',
          // appid: '',
          pagepath: '',
        },

        button_list_switch: false,
        button_list: [
          { text: '同意', style: 1, key: 'approval' },
          { text: '拒绝', style: 3, key: 'reject' },
        ],

        replace_text: '',
      },
      processKeyList: [],
      candidateUserList: [],
      noticeTemplateTypes,
      candidateUserAtributes,
      insertType: '',
      objectNames: [],
      // 记录列表页状态
      statusTab: '',
      eventTypes: '',
      // 自动复制变量
      copytext: '',
      documentLink:
        'https://developer.work.weixin.qq.com/document/path/90236#%E5%B0%8F%E7%A8%8B%E5%BA%8F%E9%80%9A%E7%9F%A5%E6%B6%88%E6%81%AF',
      systemMessageTypeList: [],
      // 代码输入框配置
      htmlOptions: {
        placeholder: '<html></html>',
        autorefresh: true,
        mode: 'text/html',
        matchBrackets: true,
        tabSize: 4,
        lineNumbers: true,
        lineWrapping: true,
      },
      jsOptions: {
        placeholder: 'var a = 1',
        autorefresh: true,
        mode: 'text/javascript',
        matchBrackets: true,
        tabSize: 4,
        lineNumbers: true,
        lineWrapping: true,
      },
      // 校验规则
      templateInfoFormRule: {
        subref: [{ required: true, message: '请选择', trigger: 'blur' }],
        system_type: [{ required: true, message: '请选择', trigger: 'blur' }],
        wxmsg_type: [{ required: true, message: '请选择', trigger: 'blur' }],
        title: [{ required: true, message: '请输入通知标题', trigger: 'blur' }],
        content: [
          { required: true, message: '请输入通知内容' },
          {
            validator: (rule, value, callback) => {
              const err = this.validateContent();
              if (err) {
                callback(err);
              } else {
                callback();
              }
            },
          },
        ],
        platform: [{ required: true, message: '请选择通知终端 ', trigger: 'change' }],
        'main_title.title': [{ required: true, message: '请输入', trigger: 'blur' }],
        'card_action.url': [{ required: true, message: '请输入', trigger: 'blur' }],
        'horizontal_content_list[0].keyname': [
          { required: true, message: '请输入', trigger: 'blur' },
        ],
        'button_list[0].text': [{ required: true, message: '请输入', trigger: 'blur' }],
      },
    };
  },
  computed: {
    ...mapGetters('user', ['getElementList']), // user 模块名称
    jurisdiction() {
      const jurisdictionArray = ['eventManage_workflow_editNoticeEvent'];
      const jurisdictionObj = {};
      for (const item of jurisdictionArray) {
        jurisdictionObj[item] = this.getElementList.includes(item);
      }

      return jurisdictionObj;
    },
    recipientVariable() {
      return this.templateInfo.wxmsg_type === 3
        ? this.candidateUserAtributes.filter((i) => i.value === 'current_assignee')
        : this.candidateUserAtributes;
    },
    generateTo2() {
      if (!this.templateInfo.to2) {
        return [];
      }
      return this.templateInfo.to2 === 'specify_variable'
        ? [this.templateInfo.variable]
        : [this.templateInfo.to2];
    },
    generateToType() {
      if (!this.templateInfo.to2) {
        return 0;
      }
      return this.templateInfo.to2 === 'specify_variable' ? 2 : 1;
    },
    previewContent() {
      return this.templateInfo.content.replaceAll('href="mailto', '');
    },
    // 只选了站内信的时候,需要选择终端
    needPlatform() {
      return this.templateInfo.subref === 'lclmsg';
    },
    horizontalContentList() {
      return this.templateInfo.horizontal_content_list;
    },
    canAddMoreContent() {
      return this.horizontalContentList?.length < 6;
    },
    canAddButton() {
      return this.button_list?.length < 6;
    },
    button_list() {
      return this.templateInfo.button_list || [];
    },
  },
  watch: {
    horizontalContentList(horizontalContentList) {
      if (horizontalContentList?.length) {
        horizontalContentList.forEach((item, index) => {
          this.templateInfoFormRule[`horizontal_content_list[${index}].keyname`] = [
            { required: true, message: '请输入', trigger: 'blur' },
          ];
        });
      }
    },
    button_list(button_list) {
      if (button_list?.length) {
        button_list.forEach((item, index) => {
          this.templateInfoFormRule[`button_list[${index}].text`] = [
            { required: true, message: '请输入', trigger: 'blur' },
          ];
        });
      }
    },
  },
  created() {
    const { id, statusTab, eventTypes } = this.$route.query;
    this.id = id;
    this.statusTab = statusTab;
    this.eventTypes = eventTypes;
    this.getSystemMessageTypes();
    if (id) {
      this.getProcessActionDetail(id);
    }
  },
  methods: {
    onSubrefChange(e) {
      if (e !== 'wxmsg') {
        this.$nextTick(() => {
          this.$refs.quillEditor.initHtml(this.templateInfo.content);
        });
      }
    },
    getCandidateUserList(name = '', delay = 300) {
      if (!name) {
        this.candidateUserList = this.templateInfo?.to?.map((value) => {
          return {
            value,
            label: value.replace(/\((.+?)\)/g, ''),
          };
        });
        return;
      }
      throttle(() => {
        this.$request({
          url: this.$api.getUserList,
          data: {
            page_size: 100,
            page: 1,
            keyword: name,
          },
          showLoading: false,
          cb: ({ data }) => {
            if (data) {
              const map = {};
              this.candidateUserList = [
                ...(this.templateInfo.to || []).map((value) => ({
                  value,
                  label: value.replace(/\((.+?)\)/g, ''),
                })),
                ...data.map((item) => ({
                  label: `${item.name}${item.description ? `-${item.description}` : ''}`,
                  value: `(${item.account})${item.name}${
                    item.description ? `-${item.description}` : ''
                  }`,
                })),
              ].reduce((prev, cur) => {
                map[cur.value] ? '' : (map[cur.value] = true && prev.push(cur));
                return prev;
              }, []);
            } else {
              this.candidateUserList = [];
            }
          },
        });
      }, delay).call(this);
    },
    getProcessActionDetail(id) {
      this.$request({
        url: this.$api.getProcessActionById,
        data: { id },
        cb: ({ process }) => {
          if (process) {
            const { name, remark, keys, template, event_key } = process;
            this.basicInfo = {
              name,
              remark,
              keys,
              event_key,
            };

            let generateTo2 = '';
            let generateVariable = '';

            const { to2 } = template.notify;
            if (!to2?.length) {
              generateTo2 = '';
            } else {
              generateTo2 = to2[0];
            }
            // 非有调用方指定变量
            if (
              generateTo2 &&
              !['current_assignee', 'last_assignee', 'starter'].includes(generateTo2)
            ) {
              generateTo2 = 'specify_variable';
              generateVariable = to2[0];
            }

            const { template_card = {} } = JSON.parse(template.notify.btn_msg_body || null) || {};
            const { source, horizontal_content_list, card_action } = template_card;
            this.templateInfo = {
              ...this.templateInfo,
              ...template.notify,
              to2: generateTo2,
              variable: generateVariable,
              ...template_card,
              source_switch: !!source,
              source: {
                desc: source?.desc || '',
                icon_url: source?.icon_url?.length ? [{ url: source.icon_url }] : [],
              },
              horizontal_content_list_switch: !!horizontal_content_list,
              card_action_switch: !!card_action,
            };
            if (this.templateInfo.subref !== 'wxmsg') {
              this.$refs.quillEditor.initHtml(this.templateInfo.content);
            }
            this.getCandidateUserList('', 0);
            if (keys.length) {
              const key1 = keys[0];
              this.$request({
                url: this.$api.metaGetObjectByRelatedWorkflow,
                data: {
                  process_def_key: key1,
                },
                cb: ({ list }) => {
                  this.objectNames = list.map((i) => i.name);
                },
              });
            }
          }
        },
      });
    },
    generateProp(parent, index, cur) {
      return `${parent}[${index}].${cur}`;
    },
    handleFileChange(val) {
      console.log(val, 'fdsfjsdlfjsdljfdsjlfjdslfjdsj');
      this.templateInfo.source.icon_url = val;
    },
    add_horizontal_content() {
      this.templateInfo.horizontal_content_list.push({ keyname: '', value: '' });
    },
    del_horizontal_content(index) {
      this.templateInfo.horizontal_content_list.splice(index, 1);
    },
    handleKeynameChange(item, index) {
      console.log(item, index);
      // this.templateInfo.horizontal_content_list[index].keyname = value;
    },
    handleValueChange(item, index) {
      console.log(item, index);

      // this.templateInfo.horizontal_content_list[index].value = value;
    },
    add_button() {
      if (!this.templateInfo.button_list?.length) {
        this.templateInfo.button_list = [];
      }
      this.templateInfo.button_list.push({ text: '', style: '', key: '' });
    },
    del_button(index) {
      this.templateInfo.button_list.splice(index, 1);
    },

    goBack() {
      this.$router.push({
        name: 'workflow-event-list',
        query: {
          statusTab: this.statusTab,
          eventTypes: this.eventTypes,
        },
      });
    },
    submitNoitceDetail() {
      this.$refs.basicForm.validate((basicValid) => {
        this.$refs.templateForm.validate(async (templateValid) => {
          if (!templateValid || !basicValid) {
            return;
          }
          if (!this.templateInfo?.to?.length && !this.templateInfo.to2) {
            this.$message.error('接收人设置至少选填一项');
            return;
          }
          if (this.templateInfo.to2 === 'specify_variable' && !this.templateInfo.variable) {
            this.$message.error('请输入指定变量');
            return;
          }

          const {
            main_title,
            source_switch,
            source,
            horizontal_content_list_switch,
            horizontal_content_list,
            card_action_switch,
            card_action,
            // button_list_switch,
            button_list,
            replace_text,
          } = this.templateInfo;
          const template_card = {
            main_title,
          };
          if (source_switch) {
            const file = await this.$refs.logo.getCosUrl();
            template_card.source = {
              ...source,
              icon_url: file?.[0]?.url ? file?.[0]?.url : '',
            };
          }
          if (horizontal_content_list_switch) {
            template_card.horizontal_content_list = horizontal_content_list;
          }
          if (card_action_switch) {
            template_card.card_action = card_action;
          }
          if (button_list?.length) {
            template_card.button_list = button_list;
          }
          if (replace_text) {
            template_card.replace_text = replace_text;
          }

          const detailData = {
            category: 1, // 1是通知事件， 2是云函数
            status: 1,
            name: this.basicInfo.name,
            event_key: this.basicInfo.event_key,
            remark: this.basicInfo.remark,
            template: {
              notify: {
                editor_type: this.templateInfo.editor_type,
                script: this.templateInfo.script,
                title: this.templateInfo.title,
                content: this.templateInfo.content,
                platform: this.templateInfo.platform,
                to: this.templateInfo.to,
                to2: this.generateTo2,
                to_type: this.generateToType,
                subref: this.templateInfo.subref,
                wxmsg_type: this.templateInfo.wxmsg_type || undefined,
                system_type: this.templateInfo.system_type || undefined,
                btn_msg_body: JSON.stringify({ template_card }),
              },
            },
          };
          if (!this.id) {
            this.createNoticeEvent(detailData);
          } else {
            delete detailData.status;
            this.updateNoticeEvent({
              id: this.id,
              ...detailData,
            });
          }
        });
      });
    },
    createNoticeEvent(data) {
      this.$request({
        url: this.$api.createProcessAction,
        data,
        cb: (resdata) => {
          if (resdata.id) {
            this.$message.success('提交成功');
            this.goBack();
          }
        },
      });
    },
    updateNoticeEvent(data) {
      this.$request({
        url: this.$api.updateProcessAction,
        data,
        cb: (resdata) => {
          if (resdata) {
            this.$message.success('提交成功');
            this.goBack();
          }
        },
      });
    },
    openMetaDiagLog(type) {
      this.insertType = type;
      this.$refs.metaDialog.openDialog();
    },
    insertion(str = '') {
      let selector = '';
      let field = '';
      if (this.insertType === 'title') {
        selector = '.notice-title .el-input__inner';
        field = 'title';
        const dom = document.querySelector(selector);
        this.templateInfo[field] = `${
          this.templateInfo[field].substring(0, dom.selectionStart) +
          str +
          this.templateInfo[field].substring(dom.selectionEnd, dom.textLength)
        }`;
      } else if (this.insertType === 'content' && this.templateInfo.subref !== 'wxmsg') {
        this.templateInfo.content += str;
      } else if (
        this.insertType === 'content' &&
        this.templateInfo.subref === 'wxmsg' &&
        this.templateInfo.wxmsg_type !== 1
      ) {
        this.copytext = str;
        this.$refs.copy.copy();
      } else {
        selector = '.notice-content .el-textarea__inner';
        field = 'content';
        const dom = document.querySelector(selector);
        this.templateInfo[field] = `${
          this.templateInfo[field].substring(0, dom.selectionStart) +
          str +
          this.templateInfo[field].substring(dom.selectionEnd, dom.textLength)
        }`;
      }
    },
    getSystemMessageTypes() {
      this.$request({
        url: this.$api.metaGetObjectByName,
        data: {
          objects: ['message'],
        },
        cb: ({ list }) => {
          if (list.length) {
            const field = list[0].fields.filter(({ name }) => name === 'type');
            this.systemMessageTypeList = field[0].select_one_option.options;
          }
        },
      });
    },
    emailMsgTypeChange() {
      this.templateInfo.content = '';
    },
    openPreview() {
      this.$refs.previewBox.show({
        title: '预览',
        width: '960px',
        top: '30vh',
        confirmText: '返回',
        exitButton: true,
        confirmAction: this.$refs.previewBox.close,
      });
    },
    openHelp() {
      this.$refs.helpBox.show({
        title: '帮助',
        width: '960px',
        top: '30vh',
        confirmText: '返回',
        exitButton: true,
        confirmAction: this.$refs.helpBox.close,
      });
    },
    validateContent() {
      if (this.needPlatform) {
        const platformFlagMap = { 1: 'wx', 2: 'web' };
        const platforms = (this.templateInfo.platform || []).map((item) => platformFlagMap[item]);
        const { content } = this.templateInfo;
        const parser = new DOMParser();
        const doc = parser.parseFromString(content, 'text/html');
        const links = doc.querySelectorAll('a');
        const hrefs = Array.from(links).map(function (link) {
          return link.getAttribute('href');
        });
        if (hrefs.length) {
          for (let i = 0; i < hrefs.length; i++) {
            const href = hrefs[i];
            const regex = /\[\(([a-zA-Z0-9]+)\).*?\]/g;
            let match;
            const plats = [];
            while ((match = regex.exec(href)) !== null) {
              plats.push(match[1]);
            }
            // 如果勾选了，而没有配对应平台的链接，则报错
            if (_.difference(platforms, plats).length) {
              return new Error('请确保为每个选中的终端填写对应的链接。');
            }
            if (_.difference(plats, platforms).length) {
              return new Error('请选择超链接对应的通知终端。');
            }
          }
        }
      }
      return null;
    },
    async handleRequest(file) {
      if (!/.png|.svg|.jpg/gi.test(file.file.name)) {
        this.$message.error('文件格式只支持svg/png/jpg');
        return false;
      }
      const pattern = new RegExp(
        "[%--`~!@#$^&*()=|{}':;',\\[\\]<>/?~！@#￥……&*（）——| {}【】‘；：”“'。，、？]",
      );
      const s = file.file.name;
      let rs = '';
      for (let i = 0; i < s.length; i++) {
        rs = rs + s.substr(i, 1).replace(pattern, '');
      }
      const cosParams = {
        imgCosKey: `${file.file.uid}${rs}`,
        fileObject: file.file,
      };
      try {
        const res = await this.putCosObject(cosParams);
        this.templateInfo.source.icon_url = res.data;
      } catch (err) {
        console.log(err);
        this.$message('上传失败，请稍后再试');
      }
    },
  },
};
